import { ContactTypeEntity } from '../entities/contact-type-entity';

export default class State {
  items: Array<ContactTypeEntity> = [];

  loaded = false;
}
